import { render, staticRenderFns } from "./candidateDetails.vue?vue&type=template&id=5bbba39c&"
import script from "./candidateDetails.vue?vue&type=script&lang=js&"
export * from "./candidateDetails.vue?vue&type=script&lang=js&"
import style0 from "./candidateDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports